var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarRecursos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_recursos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.32,
    height: 32.32,
    viewBox: "0 0 32.32 32.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M27.587,30.934H6.04A4.045,4.045,0,0,1,2,26.894V8.04A4.045,4.045,0,0,1,6.04,4h6.733a1.347,1.347,0,0,1,1.121.6l2.294,3.44h11.4a4.045,4.045,0,0,1,4.04,4.04V26.894A4.045,4.045,0,0,1,27.587,30.934ZM6.04,6.693A1.348,1.348,0,0,0,4.693,8.04V26.894A1.348,1.348,0,0,0,6.04,28.24H27.587a1.348,1.348,0,0,0,1.347-1.347V12.08a1.348,1.348,0,0,0-1.347-1.347H15.467a1.347,1.347,0,0,1-1.121-.6l-2.294-3.44Z",
    transform: "translate(-0.653 -1.307)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M0,0H32.32V32.32H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarRecursos);
export default __webpack_public_path__ + "static/media/sidebar_recursos.ac67fdf0e3b307ec1fd4e7d36d39d27b.svg";
export { ForwardRef as ReactComponent };